import { getFormValues } from 'redux-form';
import { getOr, flow } from 'lodash/fp';

export default (form) => (path, orValue) =>
  flow(getFormValues(form), getOr(orValue, path));
